import React from "react"
import ReactMarkdown from "react-markdown"
import rehypeRaw from "rehype-raw"
import remarkGfm from "remark-gfm"

import { handleLinks } from "../helpers"

const Markdown = (props) => {
  return (
    <ReactMarkdown
      components={{ link: handleLinks }}
      rehypePlugins={[rehypeRaw]}
      remarkPlugins={[remarkGfm]}
    >
      {props.children}
    </ReactMarkdown>
  )
}

export default Markdown
